// Si estamos en npm start (puerto 3000), apuntamos al puerto 8085 de Apache.
// Si ya estamos en Apache (puerto 8085 o en la IP productiva), usamos la ruta relativa '/api/user.php'.
const isDevServer = window.location.port === '3000';

const URLhttpREST = isDevServer 
  ? 'http://localhost:8085/api/user.php' 
  : '/api/user.php';

/**
* Solicitud servicio POST
*/
async function RestPOSTJSON(objGET, objPOST) {
  let getENC = '';
  let postJSON = null;

  if (!objGET && !objPOST) {
    console.warn('Advertencia: Petición sin parámetros objGET ni objPOST');
    return [];
  }

  if (objPOST !== null && objPOST !== undefined) {
    postJSON = JSON.stringify(objPOST);
  }

  if (objGET && typeof objGET === 'object') {
    getENC = '?' + Object.keys(objGET)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(objGET[key])}`)
      .join('&');
  }

  const http = new XMLHttpRequest();
  http.open("POST", URLhttpREST + getENC, true);
  http.setRequestHeader("Content-Type", "application/json");
  http.send(postJSON);

  return await http_response(http);
}

async function http_response(http) {
  const obj_rta = new Promise((resolve, reject) => {
    http.timeout = 120000;

    http.ontimeout = function() {
      console.warn(`http.status: 408 - Tiempo de espera agotado`);
      reject([]);
    };

    http.onerror = function() {
      console.warn(`http.status: 404 - Error de red o endpoint no encontrado`);
      reject([]);
    };

    http.onload = function() {
      let respuesta;
      try {
        respuesta = JSON.parse(http.response);
      } catch (error) {
        respuesta = http.response;
      }

      if (http.status === 200 || http.status === 201) {
        resolve(respuesta);
      } else {
        reject([]);
      }
    };
  });

  try {
    return await obj_rta;
  } catch (errorResult) {
    return errorResult;
  }
}

export { RestPOSTJSON };